// Cihazdan gelen label'lari client tarafinda override etmek icin map.
// Cihaz yeni getter ile dogrudan dogru label gondermeden ONCE devreye girer.
// Cihaz reload edildikten sonra bu liste kapanabilir — defensive overlay.
const LABEL_OVERRIDES = {
  cupDisabled: "Türk Kahvesi Fincan Devre Dışı",
  // Göz bazlı dem ayarları + dem rozeti gizleme — cihaz eski sürümse label
  // gelmez, key görünmesin diye override.
  brewLevel: "Dem Oranı (%)",
  constantBrew: "Sabit Dem",
  hideBrewRatio: "Dem Oranını Gizle (Ana Ekran)",
  hideProductGrams: "Ürün Gramajını Gizle",
  // Aksiyon key'i — READ data'da meta'sı yok, label buradan gelir
  resetCupsToDefault: "Bardak Kayıtlarını Varsayılana Döndür",
};

/**
 * Bir setting metadata'sini key'ine gore label override ederek doner.
 * Setting nesnesini mutate etmez — yeni obje doner.
 */
export function applyLabelOverride(key, setting) {
  if (!setting || typeof setting !== "object") return setting;
  const override = LABEL_OVERRIDES[key];
  if (!override) return setting;
  return { ...setting, label: override };
}

// Kullanıcı isteğiyle "öğütücü" ibaresi her yerde "değirmen" olarak gösterilir
// (ör. "Varsayılan Öğütücü" -> "Varsayılan Değirmen"). Cihazdan gelen ham
// label'i mutate etmeden yalnızca görüntüleme katmanında değiştirir.
const GRINDER_LABEL_PATTERN = /öğütücü|ogutucu/gi;

export function renameGrinderLabel(label) {
  if (typeof label !== "string") return label;
  return label.replace(GRINDER_LABEL_PATTERN, (match) =>
    match[0] === match[0].toUpperCase() ? "Değirmen" : "değirmen",
  );
}

/**
 * SettingsFieldCard'a giren her setting icin label'daki "öğütücü" ibaresini
 * "değirmen" ile degistirir. Setting nesnesini mutate etmez.
 */
export function applyGrinderLabelRename(setting) {
  if (
    !setting ||
    typeof setting !== "object" ||
    typeof setting.label !== "string"
  ) {
    return setting;
  }
  const renamed = renameGrinderLabel(setting.label);
  if (renamed === setting.label) return setting;
  return { ...setting, label: renamed };
}

export default LABEL_OVERRIDES;
